import { csx } from '@vtex/admin-ui'

const styles = {
  button: csx({
    marginRight: 'auto',
  }),
  radioGroupLabel: csx({
    paddingBottom: '$space-2',
  }),
  radioWithTagDescription: csx({
    '& [data-space-inside="true"] > :is(:first-child)': {
      //This selector is necessary to fix the input radio alignment when the label contains a Tag
      marginTop: '$space-1',
    },
  }),
}

export default styles
